import { AnimatePresence, motion } from "framer-motion";

// quiet nudges: the counter and its arrows sit together at the bottom, clear of the painting
const quiet = "fixed bottom-[calc(env(safe-area-inset-bottom)+1.6rem)] [.walkpad_&]:bottom-[calc(env(safe-area-inset-bottom)+11.25rem)] z-40 flex h-10 w-10 items-center justify-center rounded-full pb-0.5 font-display text-3xl leading-none text-[#4A2D55]/55 transition-[color,background-color] duration-200 hover:bg-white/50 hover:text-[#4A2D55]";
const soft = "fixed bottom-[calc(env(safe-area-inset-bottom)+1.6rem)] z-40 flex h-10 w-10 items-center justify-center rounded-full border border-white/60 bg-white/35 pb-1 font-display text-3xl leading-none text-[#4A2D55]/75 backdrop-blur-md transition-[color,background-color,transform] duration-200 hover:bg-white/70 active:scale-95";

export function RoomSteps({ onStep, guided = false, index = 0, total = 0, feeling = "", line = "" }) {
  const btn = guided ? soft : quiet;
  return (
    <>
      <button data-testid="room-prev-button" aria-label="previous painting" onClick={() => onStep(-1)} className={`${btn} left-[calc(50%-6.5rem)]`}>
        ‹
      </button>
      <button data-testid="room-next-button" aria-label="next painting" onClick={() => onStep(1)} className={`${btn} right-[calc(50%-6.5rem)]`}>
        ›
      </button>
      {guided && index > 0 && (
        <>
          <p data-testid="room-feeling-name" className="pointer-events-none fixed bottom-[calc(env(safe-area-inset-bottom)+4rem)] left-1/2 z-40 -translate-x-1/2 whitespace-nowrap rounded-2xl border border-[#E4D8C4] bg-[#FBF6EC] px-3 py-0.5 text-center font-display text-sm italic text-[#24182F]">
            {feeling}
            {/* the room's tagline, beneath its name as the visitor enters */}
            {index === 1 && line && <span data-testid="room-feeling-line" className="block text-xs not-italic text-[#5F5249]">{line}</span>}
          </p>
          <p data-testid="room-counter" className="pointer-events-none fixed bottom-[calc(env(safe-area-inset-bottom)+2.15rem)] left-1/2 z-40 -translate-x-1/2 rounded-full bg-white/35 px-3 py-0.5 font-hand text-base text-[#4A2D55]/85 backdrop-blur-md">
            {index} of {total}
          </p>
        </>
      )}
    </>
  );
}

export function RoomEnd({ show, line, nextName, onBack, onNext, onMemories }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="room-end-panel"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.4 }}
          style={{ x: "-50%" }}
          className="fixed bottom-28 left-1/2 z-40 flex w-max max-w-[92vw] flex-col items-center gap-3 rounded-3xl border border-white/70 bg-[#FBF7F2]/95 px-7 py-5 shadow-[0_18px_40px_-20px_rgba(74,45,85,0.6)] backdrop-blur-xl"
        >
          {line && <p data-testid="room-end-line" className="font-display text-2xl italic text-[#2D1E3E]">{line}</p>}
          <div className="flex flex-col items-center gap-3 sm:flex-row">
          <button data-testid="room-end-back" onClick={onBack} className="font-display text-xl text-[#4A2D55] transition-colors duration-200 hover:text-[#7E57C2]">
            ← back to the Feeling Wall
          </button>
          <span className="hidden h-6 w-px bg-[#4A2D55]/20 sm:block" />
          <button data-testid="room-end-next" onClick={onNext} className="font-display text-xl text-[#7E57C2] transition-colors duration-200 hover:text-[#4A2D55]">
            next feeling · {nextName} ›
          </button>
          </div>
          {onMemories && (
            <button data-testid="room-end-memories" onClick={onMemories} className="font-display text-base italic text-[#5C4A72] transition-colors duration-200 hover:text-[#7E57C2]">
              or, to end, sit with the memories ›
            </button>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
